import { createContext } from "react";
import { LpContextProviderProps } from "../interfaces/LogisticPartyDetails.interface";

const initialContextValue = {
  lps: [],
  dsps: [],
  authorizedLps: {},
  isFetchAuthorizedLogisticProvidersLoading: false,
  isFetchLogisticProvidersLoading: false,
};
const LPContext = createContext<LpContextProviderProps>(initialContextValue);

export default LPContext;
